// Показ Markdown (ADR-016): micromark — базовый CommonMark без расширений. Библиотека грузится
// отдельным чанком при первом показе. По умолчанию micromark экранирует HTML из текста и не делает
// ссылками опасные адреса (javascript: и т. п.), поэтому результат можно вставлять в разметку.

export type MarkdownRenderer = (text: string) => string;

let renderer: MarkdownRenderer | null = null;
let loading: Promise<MarkdownRenderer> | null = null;

/** Уже загруженный разборщик или null. */
export function loadedMarkdownRenderer(): MarkdownRenderer | null {
  return renderer;
}

export function loadMarkdownRenderer(): Promise<MarkdownRenderer> {
  if (renderer) return Promise.resolve(renderer);
  loading ??= import('micromark')
    .then(({ micromark }) => {
      renderer = (text: string) => micromark(text);
      return renderer;
    })
    .catch((error: unknown) => {
      // Чанк не загрузился (сеть) — следующая попытка начнётся заново.
      loading = null;
      throw error;
    });
  return loading;
}

export async function renderMarkdown(text: string): Promise<string> {
  return (await loadMarkdownRenderer())(text);
}
